import { useEffect, useRef, useState } from "react";
import Nav from "./Nav";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import {
  useBills,
  useAddBill,
  useUpdateShift,
  useAddAmount,
  useUpdateTiming,
} from "./api";
import { FaPrint, FaPlus } from "react-icons/fa";
import { link } from "./url";
import axios from "axios";

const getTodayString = () => {
  const MyDate = new Date();
  return (
    MyDate.getFullYear() +
    "-" +
    ("0" + (MyDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + MyDate.getDate()).slice(-2)
  );
};
const Bill = () => {
  const nav = useNavigate();

  // Current Date
  const today = getTodayString(); // compute before using in useState

  const [loading, setLoading] = useState(false);

  // UI States
  const [modalShow, setModalShow] = useState(false);
  const [modalShiftData, setModalShiftData] = useState("");
  const [modalAmountShow, setModalAmountShow] = useState(false);
  const [modalAmount, setModalAmount] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [mobile, setMobile] = useState("");
  const [m, setM] = useState("");

  // React Query
  const loadingRef = useRef(false);
  const addBill = useAddBill();
  const updateShift = useUpdateShift();
  const updatetiming = useUpdateTiming();

  const addAmount = useAddAmount();
  const [date, setDate] = useState(today);
  const [date1, setDate1] = useState(today);

  const { data, isLoading, isError, refetch } = useBills(date, date1);
  const bills = data?.out || [];
  const bal = data?.sum || 0;
  const [bals, setBal] = useState(0);
  const [searchTerm, setSearchTerm] = useState(""); // NEW
  useEffect(() => {
    if (!data) return;

    setvalue(data.out);
    setd(data.out);

    // ✅ ONLY reset rows if NO filters are active
    if (!searchTerm && !startTime && !endTime) {
      setRows(data.out);
    }
  }, [data]);

  const print = () => nav("/printdata", { state: bills });
  const submitData = async (row) => {
    if (loadingRef.current) return; // prevent double submit

    const k = Object.values(row);
    k.splice(k.length - 1, 0, today);

    if (!k[15]) {
      alert("Kindly add data");
      return;
    }

    loadingRef.current = true;

    try {
      await addBill.mutateAsync(k, {
        onSuccess: () => {
          // ❌ DO NOTHING
          // no refetch
          // no setRows
          // no setd
        },
      });

      console.log("Submitted successfully");
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      loadingRef.current = false;
    }
  };

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const applyTimeFilter = () => {
    if (!startTime || !endTime) {
      setRows(value); // reset to full (already date-filtered data)
      return;
    }

    const filtered = value.filter((d) => {
      if (!d[17]) return false;
      console.log("Row Time:", d[17]);
      console.log("Filter Range:", startTime, endTime);

      // d[17] example: "10:30 AM" OR "14:30"
      let rowTime = d[17];

      // // If backend sends datetime → extract time
      // if (rowTime.includes(" ")) {
      //   rowTime = new Date("1970-01-01 " + rowTime).toTimeString().slice(0, 5);
      // }

      return Number(d[17]) >= startTime && Number(d[17]) <= endTime;
    });

    setRows(filtered);
    setd(filtered);
  };
  const clearTimeFilter = () => {
    setStartTime("");
    setEndTime("");

    setRows(value);
  };
  const [p, setp] = useState("");
  const handleShiftClick = (shiftData, id) => {
    setModalShiftData(shiftData);
    setSelectedId(id);
    setModalShow(true);
    setp("shift");
  };
  const handletimingClick = (timingData, id) => {
    setModalShiftData(timingData);
    setSelectedId(id);
    setModalShow(true);
    setp("time");
  };

  const handleAddAmountClick = (id, me, mes) => {
    setSelectedId(id);
    setMobile(me);
    setM(mes);
    setModalAmountShow(true);
  };

  const submitAmount = () => {
    addAmount.mutate({
      id: selectedId,
      amount: modalAmount,
      mobile,
      message: m,
    });
    setModalAmountShow(false);
    setModalAmount("");
  };
  const [rows, setRows] = useState([]);
  const [d, setd] = useState([]);
  const [value, setvalue] = useState([]);
  useEffect(() => {
    if (rows && rows.length > 0) {
      const total = rows.reduce((sum, r) => sum + (Number(r[9]) || 0), 0);
      setBal(total);
    } else {
      setBal(0);
    }
  }, [rows]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isError) {
    return <div className="alert alert-danger">Error fetching bills</div>;
  }
  const searchData = (term, source = value) => {
    console.log("Searching for:", term, date);
    setSearchTerm(term); // save for later use
    const r = d.filter((k) => {
      const f0 = k[0]?.toString().toLowerCase() || "";
      const f1 = k[1]?.toString().toLowerCase() || "";
      const f2 = k[2]?.toString().toLowerCase() || "";
      const f3 = k[3]?.toString().toLowerCase() || "";
      const f4 = (k[4] + "").toLowerCase() || "";
      const t = term.toLowerCase();
      return (
        f0.includes(t) ||
        f1.includes(t) ||
        f2.includes(t) ||
        f3.includes(t) ||
        f4.includes(t)
      );
    });
    setRows(r);
  };
  const viewSales = (row) => {
    const selectedData = [
      row[0],
      row[1],
      row[5],
      row[9],
      row[6],
      row[7],
      row[8],
      row[10],
      row[11],
      row[8],
      row[12],
    ];
    nav("/viewsales", { state: selectedData });
  };

  return (
    <>
      <Nav />

      <div className="container-fluid my-4">
        {/* Summary */}
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="mb-0">Bills Found: {rows.length}</h5>
              </div>
            </div>
          </div>
          {window.localStorage.getItem("pro") === "salman" && (
            <>
              <div className="col-md-6">
                <div className="card shadow-sm">
                  <div className="card-body text-danger">
                    <h5 className="mb-0">Total Pending: {bal}</h5>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card shadow-sm">
                  <div className="card-body text-danger">
                    <h5 className="mb-0">Current Total Pending: {bals}</h5>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="row mb-3">
          <div className="col-md-3">
            <select
              className="form-control"
              value={startTime}
              onChange={(e) =>
                setStartTime(
                  e.target.value === "" ? "" : Number(e.target.value)
                )
              }
            >
              <option value="">Start Time</option>
              {[...Array(24)].map((_, i) => (
                <option key={i} value={i}>
                  {String(i).padStart(2, "0")}:00
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <select
              className="form-control"
              value={endTime}
              onChange={(e) =>
                setEndTime(e.target.value === "" ? "" : Number(e.target.value))
              }
            >
              <option value="">End Time</option>
              {[...Array(24)].map((_, i) => (
                <option key={i} value={i}>
                  {String(i).padStart(2, "0")}:00
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <Button
              variant="secondary"
              className="w-100"
              onClick={applyTimeFilter}
            >
              Time Filter
            </Button>
          </div>

          <div className="col-md-3">
            <Button
              variant="outline-dark"
              className="w-100"
              onClick={clearTimeFilter}
            >
              Clear Time
            </Button>
          </div>
        </div>

        {/* Filters */}
        <div className="row g-2 sticky-top bg-white py-2 border-bottom">
          <div className="col-md-3">
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-3">
            <input
              type="date"
              value={date1}
              onChange={(e) => setDate1(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-2">
            <Button
              onClick={() => {
                refetch();
              }}
              variant="danger"
              className="w-100"
            >
              Filter
            </Button>
          </div>
          <div className="col-md-2">
            <Button onClick={print} variant="primary" className="w-100">
              <FaPrint /> Print
            </Button>
          </div>
          <div className="col-md-2">
            <input
              type="search"
              onChange={(e) => searchData(e.target.value, rows)}
              className="form-control"
              placeholder="Search..."
            />
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive mt-3">
          <table className="table table-striped table-hover table-bordered align-middle">
            <thead className="table-dark">
              <tr>
                <th>Billid</th>
                <th>Shift</th>
                <th>Timing</th>
                <th>Name</th>
                <th>Balance</th>
                <th>PAmount</th>
                <th>Cdate</th>

                <th>Submit</th>
                <th>Area</th>
                <th>Mobile</th>
                <th>Product</th>
                <th>Price</th>
                <th>Mode</th>
                <th>Day</th>
                <th>Paymentdate</th>
                <th>Add Amount</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((d, index) => (
                <tr key={d[0]}>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => viewSales(d)}
                    >
                      {d[0]}
                    </button>
                  </td>

                  <td
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleShiftClick(d[13], d[0])}
                  >
                    {d[13]}
                  </td>
                  <td
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => handletimingClick(d[17], d[0])}
                  >
                    {d[17]}
                  </td>
                  <td>
                    <a
                      href={`tel:${d[4]}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {d[2]}
                    </a>
                  </td>
                  <td>{d[9]}</td>
                  <td>
                    <input
                      type="text"
                      size={4}
                      value={d[15] || ""}
                      onChange={(e) =>
                        setRows((prev) =>
                          prev.map((row, i) =>
                            i === index ? { ...row, 15: e.target.value } : row
                          )
                        )
                      }
                    />
                  </td>

                  {/* Date Input */}
                  <td>
                    <input
                      type="date"
                      value={d[16] || ""}
                      onChange={(e) =>
                        setRows((prev) =>
                          prev.map((row, i) =>
                            i === index ? { ...row, 16: e.target.value } : row
                          )
                        )
                      }
                    />
                  </td>

                  <td>
                    <button
                      className="btn btn-secondary"
                      style={{ padding: "8px 16px" }}
                      onClick={async (e) => {
                        const btn = e.currentTarget;
                        btn.disabled = true;
                        btn.innerText = "Submitting...";

                        try {
                          await submitData(d);
                        } finally {
                          btn.disabled = false;
                          btn.innerText = "Submit";
                        }
                      }}
                    >
                      Submit
                    </button>
                  </td>
                  <td>{d[3]}</td>

                  <td>
                    <a
                      href={`tel:${d[4]}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {d[4]}
                    </a>
                  </td>

                  <td>{d[5]}</td>
                  <td>{d[6]}</td>
                  <td>{d[7]}</td>
                  <td>{d[8]}</td>
                  <td>{d[10]}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleAddAmountClick(d[0], d[4], d[14])}
                    >
                      <FaPlus /> Amount
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Shift Modal */}
      {p === "shift" ? (
        <Modal show={modalShow} onHide={() => setModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Shift Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Select
              value={modalShiftData}
              onChange={(e) => setModalShiftData(e.target.value)}
            >
              <option>G</option>
              <option>M</option>
              <option>E</option>
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                updateShift.mutate({ id: selectedId, value: modalShiftData });
                setModalShow(false);
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal show={modalShow} onHide={() => setModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Timing Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              value={modalShiftData}
              onChange={(e) => setModalShiftData(e.target.value)}
              placeholder="Enter Timing"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                axios.post(link + "salman/updatetiming", {
                  id: selectedId,
                  value: modalShiftData,
                });

                setModalShow(false);
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Add Amount Modal */}
      <Modal show={modalAmountShow} onHide={() => setModalAmountShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Amount for Bill #{selectedId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="number"
            value={modalAmount}
            onChange={(e) => setModalAmount(e.target.value)}
            placeholder="Enter Amount"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={submitAmount}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Bill;
